module.exports = __webpack_public_path__ + "static/img/ygfc6.18e1af2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/ygfc6.png
// module id = O2oh
// module chunks = 2